import { Route, Routes as RouterRoutes } from "react-router-dom";
import MapView from "./views/Map/MapView";
import Catalog from "./views/Catalog/Catalog";
import EventDetail from "./views/EventDetail/EventDetail";
import About from "./views/About/About";
import Contact from "./views/Contact/Contact";

export const routeList = [
  {
    path: "/",
    element: <MapView />,
    title: "Lunamalies | Lunar Anomaly Archive",
  },
  {
    path: "/catalog",
    element: <Catalog />,
    title: "Catalog | Lunamalies",
  },
  {
    path: "/events/:id",
    element: <EventDetail />,
    title: "Event | Lunamalies",
  },
  {
    path: "/about",
    element: <About />,
    title: "About | Lunamalies",
  },
  {
    path: "/contact",
    element: <Contact />,
    title: "Contact | Lunamalies",
  },
];

export const AppRoutes = () => (
  <RouterRoutes>
    {routeList.map((route) => (
      <Route key={route.path} path={route.path} element={route.element} />
    ))}
  </RouterRoutes>
);
